import { useCallback } from "react";
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

export function useGoogleAnalyticsAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  // helper to add startDate & endDate to URL
  const withQuery = (url, startDate, endDate) => {
    return `${url}?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  };
 
  const getEventsAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/events`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getClicksPerPageAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/clicks-per-page`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getSessionDurationAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/session-duration`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getEngagedSessionsAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/engaged-sessions`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getNewUsersAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/new-users`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);
  const getActiveUsersAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/active-users`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getViewsPerSessionAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/views-per-session`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getUsersByCityAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/users-by-city`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getPageViewsAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/page-views`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getUsersByCountryAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/users-by-country`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getNewVsReturningUsersAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/new-vs-returning`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getTopBrowsersAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/top-browsers`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getDeviceCategoryAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/device-category`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);
  const getStartDateAPI = useCallback(async () => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/start-date`),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);

  const getTrafficSourcesAPI = useCallback(async (startDate, endDate) => {
    try {
      const res = await fetch(
        withQuery(`${config.host}/cdr-panel/google-dashboard/traffic-sources`, startDate, endDate),
        { method: "GET", credentials: "include" }
      );
      return handleResponse(res); 
    } catch (err) {
      handleError(err);
    }
  }, [handleResponse, handleError]);


  async function getShiptoTrafficAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/google-dashboard/customer-traffic?query=${query}`,
        obj
      );
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  return {
    getEventsAPI,
    getClicksPerPageAPI,
    getSessionDurationAPI,
    getEngagedSessionsAPI,
    getActiveUsersAPI,
    getNewUsersAPI,
    getViewsPerSessionAPI,
    getUsersByCityAPI,
    getPageViewsAPI,
    getUsersByCountryAPI,
    getNewVsReturningUsersAPI,
    getTopBrowsersAPI,
    getDeviceCategoryAPI,
    getTrafficSourcesAPI,
    getStartDateAPI,
    getShiptoTrafficAPI
  };
}
